import React from 'react';
import { Col, Row } from '../../lib/utils';
import DonutChart from './DonutChart';
import { Body2Bold, Body3Regular, Head4 } from '../../lib/font';
import { colors } from '../../lib/colors';

const DashBoardDonutChart = ({ chartData, completedClass, totalClass }: any) => {
    const width = 220;
    const height = 220;
    const outerRadius = 101;
    const innerRadius = 88;
    const progress = totalClass > 0 ? Math.ceil((completedClass / totalClass) * 100) : 0;

    return (
        <Row
            style={{
                width: 220,
                height: 220,
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                borderRadius: 32,
                background: 'linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(239,246,255,0.92) 100%)',
                border: '1px solid rgba(191,219,254,0.95)',
                boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.72), 0 16px 32px rgba(59,130,246,0.08)',
            }}
        >
            {chartData && <DonutChart data={chartData} totalValue={totalClass} />}

            <Col
                style={{
                    position: 'absolute',
                    zIndex: 2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 118,
                    height: 118,
                    borderRadius: 999,
                    background: 'rgba(255,255,255,0.94)',
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.85)',
                }}
            >
                <Row style={{ alignItems: 'flex-end', justifyContent: 'center' }}>
                    <Head4 style={{ color: '#0F172A', lineHeight: 1 }}>{progress}</Head4>
                    <Body2Bold style={{ color: '#1D4ED8', marginBottom: 2 }}>%</Body2Bold>
                </Row>
                <Body3Regular style={{ color: '#64748B', marginTop: 4 }}>스케줄 진행도</Body3Regular>
            </Col>

            <svg width={width} height={height} style={{ zIndex: 0.5, position: 'absolute' }}>
                <circle cx={width / 2} cy={height / 2} r={outerRadius} fill="#D9E5F6" />
                <circle cx={width / 2} cy={height / 2} r={innerRadius} fill="white" />
            </svg>
        </Row>
    );
};

export default DashBoardDonutChart;
